import React, { useState } from 'react'
import { BlogSlider } from '@ashleynexvelsolutions/blog-slider'
import { CalloutV4 } from '@ashleynexvelsolutions/callout-v4'
import { ContactV4 } from '@ashleynexvelsolutions/contact-v4'
import { CouponDescription } from '@ashleynexvelsolutions/coupon-description'
import { CouponSliderV3 } from '@ashleynexvelsolutions/coupon-slider-v3'
import { CouponV4 } from '@ashleynexvelsolutions/coupon-v4'
import { DataPins } from '@ashleynexvelsolutions/data-pins'
import { FaqV2 } from '@ashleynexvelsolutions/faq-v2'
import { FeaturedServicesV3 } from '@ashleynexvelsolutions/featured-services-v3'
import { InteriorContentV2 } from '@ashleynexvelsolutions/interior-content-v2'
import { InteriorHeroV5 } from '@ashleynexvelsolutions/interior-hero-v5'
import { LatestBlogV5 } from '@ashleynexvelsolutions/latest-blog-v5'
import { MultiStepFormV4 } from '@ashleynexvelsolutions/multi-step-form-v4'
import { OurWork } from '@ashleynexvelsolutions/our-work'
import { PageSpecificSchema } from '@ashleynexvelsolutions/page-specific-schema'
import { Portal } from '@ashleynexvelsolutions/portal'
import { Seo2 } from '@ashleynexvelsolutions/seo2'
import { ServiceAreasV6 } from '@ashleynexvelsolutions/service-areas-v6'
import { ServicesMenuV2 } from '@ashleynexvelsolutions/services-menu-v2'
import { graphql, Script } from 'gatsby'
import { Layout } from '../components/Layout'
import {
  SeoFunction,
  PageSpecificSchemaFunction,
  InteriorHeroFunction,
  LatestBlogsFunction,
  ServiceAreasFunction,
  ContactFunction,
  FeaturedServicesFunction,
  CalloutFunction,
  ServicesMenuFunction,
  InteriorContent1,
  InteriorContent2,
  FaqFunction,
  InteriorCouponsFunction,
  BlogSliderFunction,
  OurWorkFunction,
  CouponFunction,
  CouponDescriptionFunction,
  MultiStepFormFunction,
  DataPinsFunction,
} from '../DataImports'
import { useOurCouponsQuery } from '../hooks/use-our-coupons-query'
import { useOurServicesMenuQuery } from '../hooks/use-our-services-menu-query'

const Page = ({ data }) => {
  // eslint-disable-next-line no-unused-vars
  const [formModal, setFormModal] = useState(false)

  const handleButton = () => setFormModal(true)

  const sidebarMenu = useOurServicesMenuQuery()
  const { wpPage } = useOurCouponsQuery()
  return (
    <Layout>
      <InteriorHeroV5 {...InteriorHeroFunction(data, handleButton)} />
      <div className="bg-white pt-16">
        <section className="container grid lg:grid-cols-[34%_60%] lg:gap-x-[6%] mx-auto max-w-[1197px] xxl:px-0 pb-28">
          <main className="lg:row-start-1 lg:row-end-1 lg:col-start-2 lg:col-end-2">
            <div className="page">
              <InteriorContentV2 {...InteriorContent1(data)} />
              {data.wpPage.title === 'Reviews' && (
                <div className="mb-6">
                  <Script id="reviewScript" src={process.env.GATSBY_BIRDEYE_REVIEW_URL} />
                  <div id={process.env.GATSBY_BIRDEYE_REVIEW_ID} />
                </div>
              )}
              {data.wpPage.title === 'Coupons' && (
                <div className="grid mb-6 lg:grid-cols-2 lg:gap-x-14 couponsPageCoupons">
                  {wpPage.ourCoupons.coupons.coupons.map(coupon => {
                    return (
                      <div className="lg:w-[380px]" key={coupon.text}>
                        <CouponV4 {...CouponFunction(coupon)} />
                        {coupon.description !== null && (
                          <CouponDescription {...CouponDescriptionFunction(coupon)} />
                        )}
                      </div>
                    )
                  })}
                </div>
              )}
              {data.wpPage.title === 'Our Work' && (
                <div className="mb-6">
                  <OurWork {...OurWorkFunction()} isHome={false} />
                </div>
              )}
              <CalloutV4 {...CalloutFunction(handleButton)} />
              <div className="mt-6">
                <InteriorContentV2 {...InteriorContent2(data)} />
              </div>
              {data.wpPage.nexvelschemapagesposts.questionsAndAnswers !== null && (
                <FaqV2 {...FaqFunction(data)} />
              )}
            </div>
          </main>
          <aside className="mt-8 lg:mt-0 lg:row-start-1 lg:row-end-1 lg:col-start-1 lg:col-end-1">
            <p className="text-blue-dark3 font-heading font-extrabold text-[44px]">
              {sidebarMenu.nodes[0].menu.node.name}
            </p>
            <ServicesMenuV2 {...ServicesMenuFunction()} />
            <div className="w-[330px] lg:w-full m-auto">
              <CouponSliderV3 {...InteriorCouponsFunction()} />
            </div>
            <div className="w-[330px] lg:w-full m-auto mt-8">
              <BlogSlider {...BlogSliderFunction()} />
            </div>
          </aside>
        </section>
        {data.wpPage.dataPins.dataPins.weatherWidget !== null && (
          <div className="mt-8 container ">
            <DataPins {...DataPinsFunction(data)} />
          </div>
        )}
        <FeaturedServicesV3 {...FeaturedServicesFunction()} />
        <LatestBlogV5 {...LatestBlogsFunction()} />
        <ServiceAreasV6 {...ServiceAreasFunction()} />
        <ContactV4 {...ContactFunction()} />
      </div>
      <PageSpecificSchema {...PageSpecificSchemaFunction(data)} />

      {formModal === true && (
        <Portal
          isOpen
          onClose={() => setFormModal(false)}
          xColor="text-orange"
          maxWidth="max-w-full"
          padding="p-0"
          width="w-full lg:w-auto"
          background="bg-white/[0.9]"
        >
          <MultiStepFormV4 {...MultiStepFormFunction()} />
        </Portal>
      )}
    </Layout>
  )
}
export const query = graphql`
  query ($id: String!) {
    wpPage(id: { eq: $id }) {
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphUrl
        opengraphSiteName
        opengraphType
        opengraphImage {
          localFile {
            publicURL
          }
        }
        canonical
        twitterTitle
        twitterDescription
        twitterImage {
          localFile {
            publicURL
          }
        }
      }
      nexvelschemapagesposts {
        videos {
          title
          url
          description
          thumbnailImage {
            localFile {
              publicURL
            }
          }
          uploadDate
        }
        questionsAndAnswers {
          question
          answer
        }
        maps {
          mapUrl
        }
        digitaldocuments {
          title
        }
        images {
          image {
            localFile {
              publicURL
            }
            date(formatString: "LL")
            description
            title
          }
        }
        areaServedLandingPageSchema
        serviceSchema {
          serviceNameSchema
          linkToRelevantServicePageSchema
        }
        keywordsSchema {
          keywordSchema
        }
        localAwardsSchema {
          localAwardSchema
        }
        latitudeSchema
        longitudeSchema
        relevantExternalPagesSchema {
          relevantExternalPageSchema
        }
      }
      contentSection1 {
        contentSection1
      }
      contentSection2 {
        contentSection2
      }
      dataPins {
        dataPins {
          weatherWidget
          mapCenter {
            latitude
            longitude
          }
          cards {
            name
            date
            description
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(quality: 100)
                }
              }
            }
          }
        }
      }
      title
      uri
      featuredImage {
        node {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, quality: 100, formats: WEBP)
            }
          }
        }
      }
      interiorHero {
        title
        subtitle
      }
    }
    wp {
      nexvelSchemaMarkup {
        nexvelschema {
          cities {
            city
          }
          services {
            service
            linkToRelevantPageOnYourWebsite
          }
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`
export default Page
export const Head = ({ data }) => (
  <>
    <meta name="facebook-domain-verification" content="4f3e8jrydf5vf3kjibdgrf7md9hibm" />
    <Seo2 {...SeoFunction(data)} />
  </>
)
